import { render } from "./Loader.vue?vue&type=template&id=e79ec684"
const script = {}

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e79ec684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e79ec684', __exports__)) {
    console.log('reload')
    api.reload('e79ec684', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=e79ec684", () => {
    console.log('re-render')
    api.rerender('e79ec684', render)
  })

}


export default __exports__